<!--
 * @Author:
 * @LastEditTime: 2024-09-18 22:58:06
 * @Description:
-->
<template>
  <div class="w-full h-full model-view">
    <div id="map" :style="{ width: '100%', height: '100%' }"></div>
    <div
      id="popup"
      class="ol-popup absolute bg-[#1b95b3] rounded-lg border-1 border-gray-300 pt-10px pr-16px pb-6px pl-6px min-w-220px"
    >
      <a
        href="#"
        id="popup-closer"
        class="ol-popup-closer absolute right-3px top-0 no-underline"
      ></a>
      <div id="popup-content" class="text-white text-12px leading-4">
        <p>项目名称：测试项目1212</p>
        <p>所属单位：新疆油田采油工厂</p>
        <p>项目类型：油田产建</p>
        <p>建设地点：测试项目1212</p>
        <p>项目状态：在建中</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Map, View, Overlay, Feature } from 'ol' // 地图,视图
import { TileWMS, Vector as VectorSource, XYZ } from 'ol/source'
import { Icon, Style } from 'ol/style'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
import { transform } from 'ol/proj'
import { ScaleLine, defaults as defaultControls } from 'ol/control'
import { Point } from 'ol/geom'
import { find, forEach, valuesIn, map, join } from 'lodash'
import projectNavigationTenant from '../../service/ProjectNavigationTenant'

let mapObj = null
export default {
  name: 'GisView',
  data() {
    return {
      projects: [],
      // 临时经纬坐标映射集合
      lnglatMap: {
        'KFGS-01': [86.82, 45.42],
        'CS-0001': [86.82, 45.8],
        'CYEC-2024-001': [85.10516, 45.68327],
      },
    }
  },
  methods: {
    // 获取租户列表
    async getTenantList() {
      const [err, res] = await projectNavigationTenant.getCurrentTenantList()
      if (res && res.Code === 1) {
        this.projects = map(res.Data, (item) => {
          return {
            // lonLat: this.lnglatMap[item.Code] || [86.82, 45.68327],
            Id: item.Id,
            lonLat: [Number(item.Longitude), Number(item.Latitude)],
            TenantName: item.TenantName,
            OrgName: item.OrgName,
            ProjectTypeDic: join(valuesIn(item.ProjectTypeDic), '、'),
            ProjectStatusStr: item.ProjectStatusStr,
            Position: join(JSON.parse(item.Position), '') + (item.Address || ''),
          }
        })
      }
    },
    initMap() {
      // 将地理坐标转换为投影坐标
      // 'EPSG:4326'是一个常见的坐标系标准代码  EPSG:3857坐标系主要用于web地图和地理信息系统的显示 虽然EPSG:3857坐标系在web地图和地理信息系统中广泛使用，但它是一种特定的地图投影，可能会导致坐标精度的问题
      const center = transform([87.5, 45], 'EPSG:4326', 'EPSG:3857')
      console.log(center)
      mapObj = new Map({
        target: 'map',
        layers: [
          // 添加底图
          new TileLayer({
            // 注意这里用的是TileWMS类而不是ImageWMS类
            source: new XYZ({
              url: 'http://t0.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=da1388b09287392cc479878d10e3ca18',
              params: {
                LAYERS: 'R_202300DMGC20231221新疆dom', // 请求的图层名
              },
              serverType: 'geoserver', // 服务器类型
              transition: 0, // 呈现不透明度转换的持续时间
            }),
          }),
          // 添加图层
          new TileLayer({
            // 注意这里用的是TileWMS类而不是ImageWMS类
            source: new TileWMS({
              url: 'http://11.71.6.24:8080/rsmse/tcfw/F_202200DMGC20231222盆地边界/wms?tk=eyJhbGciOiJIUzI1NiIsInppcCI6IkRFRiJ9.eNpMy0EKgzAQBdC7_HUWmUT_mNwmoGAEWzGRFoJ3b92Iy7d4DemoM2LDlkr5vPcREWlc8wsG-YmjTPvN02Cp-U_xQZVexIaBFKeeV0wVUeicHZQMBtN3Q_Su69mxp54_AAAA__8.MekGHcyT1FYnWDgqj67DMyxhlW7sEc1I5Y2bF-ELXJo', // WMS服务的URL.//request=GetCapabilities&version=1.3.0&service=wms
              // WMS请求参数
              params: {
                LAYERS: 'F_202200DMGC20231222盆地边界', // 请求的图层名
              },
              serverType: 'geoserver', // 服务器类型
              transition: 0, // 呈现不透明度转换的持续时间
            }),
          }),
          new TileLayer({
            // 注意这里用的是TileWMS类而不是ImageWMS类
            source: new TileWMS({
              url: 'http://11.71.6.24:8080/rsmse/地面工程/F_2209DM23120000采油厂范围/wms?request=GetCapabilities&version=1.3.0&service=wms&tk=eyJhbGciOiJIUzI1NiIsInppcCI6IkRFRiJ9.eNpMy0EKgzAQBdC7_HUWmUT_mNwmoGAEWzGRFoJ3b92Iy7d4DemoM2LDlkr5vPcREWlc8wsG-YmjTPvN02Cp-U_xQZVexIaBFKeeV0wVUeicHZQMBtN3Q_Su69mxp54_AAAA__8.MekGHcyT1FYnWDgqj67DMyxhlW7sEc1I5Y2bF-ELXJo', // WMS服务的URL.//request=GetCapabilities&version=1.3.0&service=wms
              // WMS请求参数
              params: {
                LAYERS: 'F_2209DM23120000采油厂范围', // 请求的图层名
              },
              serverType: 'geoserver', // 服务器类型
              transition: 0, // 呈现不透明度转换的持续时间
            }),
          }),
        ],
        controls: defaultControls({
          rotate: false,
        }),
        view: new View({
          center,
          // projection: "EPSG:4326",
          zoom: 9,
          maxZoom: 16,
          minZoom: 4,
        }),
      })
      // 创建悬浮弹框矢量图层
      const container = document.getElementById('popup')
      const content = document.getElementById('popup-content')
      const closer = document.getElementById('popup-closer')
      const overlayPopup = new Overlay({
        element: container,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
        offset: [-20, -10],
      })
      mapObj.addOverlay(overlayPopup)
      closer.onclick = function () {
        overlayPopup.setPosition(undefined)
        closer.blur()
        return false
      }
      // 鼠标放置在要素上变为小手
      mapObj.on('pointermove', (e) => {
        const pixel = mapObj.getEventPixel(e.originalEvent)
        const hit = mapObj.hasFeatureAtPixel(pixel)
        if (hit) {
          mapObj.getTargetElement().style.cursor = 'pointer'
        } else {
          mapObj.getTargetElement().style.cursor = ''
          // 关闭悬浮框
          overlayPopup.setPosition(undefined)
        }
      })
      // 地图点击事件
      mapObj.on('click', (evt) => {
        // 判断当前点击处是否有要素，如果有则获取要素
        const feature = mapObj.forEachFeatureAtPixel(evt.pixel, (feature) => {
          return feature
        })
        if (!feature) {
          return
        }
        const currentItem = feature.get('dataInfo')
        const pos = transform(currentItem.lonLat, 'EPSG:4326', 'EPSG:3857')
        mapObj.getView().animate({
          // 地图移动到点击元素坐标处
          center: pos,
          duration: 250,
          zoom: 10,
        })
      })
      mapObj.on('pointermove', (evt) => {
        // 判断当前点击处是否有要素，如果有则获取要素
        const feature = mapObj.forEachFeatureAtPixel(evt.pixel, (feature) => {
          return feature
        })
        if (!feature) {
          return
        }
        // const coordinate = evt.coordinate // 获取的是投mapObj影坐标系
        // const hdms = toStringHDMS(toLonLat(coordinate));
        const currentItem = feature.get('dataInfo')
        const pos = transform(currentItem.lonLat, 'EPSG:4326', 'EPSG:3857')
        content.innerHTML = `
         <p>项目名称：${currentItem.TenantName}</p>
         <p>所属组织：${currentItem.OrgName}</p>
         <p>项目类型：${currentItem.ProjectTypeDic}</p>
         <p>建设地点：${currentItem.Position}</p>
         <p>项目状态：${currentItem.ProjectStatusStr}</p>
         `
        overlayPopup.setPosition(pos)
      })
    },
    // 比例尺
    initScaleLine() {
      const scaleLineControl = new ScaleLine({
        className: 'my-scale-line',
      })
      scaleLineControl.setUnits('metric')
      mapObj.addControl(scaleLineControl)
    },
    // 添加水滴图片标注
    addPicMarker(item) {
      const createMarker = function (features) {
        return new Style({
          image: new Icon({
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            anchorOrigin: 'top-right',
            offsetOrigin: 'top-right',
            scale: 0.35,
            src: require('../../assets/images/GISLocation.png'),
          }),
        })
      }
      // 实例化Vector要素，通过矢量图层添加到地图容器中
      const iconFeatures = new Feature({
        geometry: new Point(transform(item.lonLat, 'EPSG:4326', 'EPSG:3857')),
        name: item.TenantName,
        dataInfo: item,
        population: 4000,
        rainfall: 500,
      })
      iconFeatures.setStyle(createMarker(iconFeatures))
      // 矢量标注的数据源
      const vectorSource = new VectorSource({
        features: [iconFeatures],
      })
      // 矢量标注图层
      const vectorLayer = new VectorLayer({
        source: vectorSource,
      })
      mapObj.addLayer(vectorLayer)
    },
  },
  async mounted() {
    await this.getTenantList()
    await this.initMap()
    await this.initScaleLine()
    // 循环创建所有项目站点
    forEach(this.projects, (item) => {
      if (item.Id !== '00000000-0000-0000-0000-000000000000') {
        console.log(item.Id, 222222222)
        this.addPicMarker(item)
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.model-view {
  transform: scale(1, 1);
  transform-origin: 'top left';
}

.chulizhan {
  background: #ffffffbf;
}
// 天地图弹框
.ol-popup {
  bottom: 50%;
  left: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.ol-popup::after,
.ol-popup::before {
  position: absolute;
  top: 100%;
  width: 0;
  height: 0;
  border: solid transparent;
  content: ' ';
  pointer-events: none;
}

.ol-popup::after {
  left: 20px;
  margin-left: -6px;
  border-width: 6px;
  border-top-color: #1b95b3;
}

.ol-popup::before {
  left: 20px;
  margin-left: -6px;
  border-width: 6px;
  border-top-color: #1b95b3;
}

.ol-popup-closer::after {
  font-size: 14px;
  color: #fff;
  content: 'X';
}

.my-scale-line {
  position: absolute;
  right: auto;
  bottom: 60px;
  left: 50px;
  height: 8px;
  font-size: 12px;
  text-align: center;
  color: black;
  background-color: hsla(0deg, 0%, 100%, 0);
  border: 2px solid black;
  font-weight: 700;
  border-top: none;
  line-height: 0;
}
</style>
